//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Searchbar from './_components/Searchbar';
import { cleanObj } from '~/utils';

export default {
  name: 'Course',
  components: { Searchbar },
  data() {
    return {
      courseList: [],
    };
  },
  head() {
    return {
      title: 'STEP1NE 培訓課程 - 職業發展與技能提升',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '提升職業技能 - STEP1NE培訓課程',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '探索STEP1NE提供的培訓課程，涵蓋信息科技、製造業、商業服務等領域，專為職場人士設計，助您職業發展與技能提升。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '探索STEP1NE提供的培訓課程，涵蓋信息科技、製造業、商業服務等領域，專為職場人士設計，助您職業發展與技能提升。',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  methods: {
    getLecturerCourse(payload = {}) {
      this.$api('getLecturerCourse', cleanObj(payload, true)).then(data => {
        this.courseList = data.records;
      });
    },
    onSearch(payload) {
      this.getLecturerCourse(payload);
    },
  },
  watch: {
    token() {
      // 登入後 重撈課程資訊
      if (this.token) this.getLecturerCourse();
    },
  },
  mounted() {
    this.getLecturerCourse();
  },
};
